import React from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout } from '../hooks/useMetaPixel';
interface CTAButtonProps {
  text: string;
  href?: string;
  size?: 'lg' | 'xl';
  className?: string;
}
export function CTAButton({
  text,
  href = '#oferta',
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const baseClasses = 'inline-flex items-center justify-center font-bold text-white bg-gold hover:bg-gold-light rounded-full shadow-lg transition-colors duration-300 text-center cursor-pointer';
  const sizeClasses = size === 'xl' ? 'px-8 py-4 text-xl md:text-2xl' : 'px-6 py-3 text-lg';
  return <motion.a href={href} {...!isAnchor && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }} onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isAnchor) {
      e.preventDefault();
      const target = document.querySelector(href);
      target?.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      e.preventDefault();
      trackInitiateCheckout().then(() => {
        window.open(href, '_blank', 'noopener,noreferrer');
      });
    }
  }} className={`${baseClasses} ${sizeClasses} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} initial={{
    opacity: 0.9
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(212, 160, 23, 0.4)', '0px 0px 0px 15px rgba(212, 160, 23, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity
    }
  }} data-id="element-1">
      {text}
    </motion.a>;
}